export default {"src":"/_next/static/image/public/images/ic_contact.599dbb06f5758d8d07194569da8331c8.svg","height":34,"width":34};